import { RedeemCode, RedeemCodeResponse } from 'mytours-read-api-typescript'
import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'

import * as apiActions from '../api/actions'
import { CodeStatus } from './types'

export interface StoreState {
	readonly couponCode?: string
	readonly linkedId?: number
	readonly linkedType?: RedeemCode.LinkedTypeEnum
	readonly app: CodeStatus
	readonly collection: CodeStatus
}

export const INITIAL_STATE: StoreState = {
	couponCode: '',
	app: {
		loading: false,
		loaded: false,
		status: undefined,
	},
	collection: {
		loading: false,
		loaded: false,
		status: undefined,
	},
}

export const reducer = reducerWithInitialState(INITIAL_STATE)
	.cases(
		[apiActions.validateCode.started, apiActions.redeemCode.started],
		(state, payload): StoreState => {
			const { couponCode, linkedId, linkedType } = payload

			switch (linkedType) {
				case RedeemCode.LinkedTypeEnum.App:
					return {
						...state,
						app: {
							...INITIAL_STATE.app,
							loading: true,
						},
						couponCode,
						linkedId,
						linkedType,
					}
				case RedeemCode.LinkedTypeEnum.Collection:
					return {
						...state,
						collection: {
							...INITIAL_STATE.collection,
							loading: true,
						},
						couponCode,
						linkedId,
						linkedType,
					}
				default:
					return { ...INITIAL_STATE }
			}
		},
	)

	.case(
		apiActions.redeemCode.done,
		(state, payload): StoreState => {
			const {
				result: { status },
				params: { linkedType },
			} = payload

			switch (linkedType) {
				case RedeemCode.LinkedTypeEnum.App:
					return {
						...state,
						app: {
							loading: false,
							loaded: true,
							status,
						},
					}
				case RedeemCode.LinkedTypeEnum.Collection:
					return {
						...state,
						collection: {
							loading: false,
							loaded: true,
							status,
						},
					}
				default:
					return { ...state }
			}
		},
	)
	.case(
		apiActions.validateCode.done,
		(state, payload): StoreState => {
			let {
				result: { status },
				params: { linkedType },
			} = payload

			// Ignore max redemptions and requires email when validating
			status = (status === RedeemCodeResponse.StatusEnum.MaxRedemptions || status === RedeemCodeResponse.StatusEnum.RequiresEmail) ? RedeemCodeResponse.StatusEnum.Valid : status

			switch (linkedType) {
				case RedeemCode.LinkedTypeEnum.App:
					return {
						...state,
						app: {
							loading: false,
							loaded: true,
							status,
						},
					}
				case RedeemCode.LinkedTypeEnum.Collection:
					return {
						...state,
						collection: {
							loading: false,
							loaded: true,
							status,
						},
					}
				default:
					return { ...state }
			}
		},
	)

	.cases(
		[apiActions.validateCode.failed, apiActions.redeemCode.failed],
		(state, payload): StoreState => {
			const {
				params: { linkedType },
			} = payload

			switch (linkedType) {
				case RedeemCode.LinkedTypeEnum.App:
					return {
						...state,
						app: {
							loading: false,
							loaded: true,
							status: RedeemCodeResponse.StatusEnum.Invalid,
						},
					}
				case RedeemCode.LinkedTypeEnum.Collection:
					return {
						...state,
						collection: {
							loading: false,
							loaded: true,
							status: RedeemCodeResponse.StatusEnum.Invalid,
						},
					}
				default:
					return { ...state }
			}
		},
	)
